import {Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ButtonTypeEnum} from '@shared/button/button.directive';
import {Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {LibraryActions} from '@store/library';
import {ActivatedRoute} from '@angular/router';
import {ExtensionHelper} from '@shared/helpers/extension-helper.service';
import {MultiSelectInterface} from '@shared/interfaces/multi-select.interface';

@Component({
    selector: 'app-filter-add-source-dialog',
    templateUrl: './filter-source-dialog.component.html',
    styleUrls: ['./filter-source-dialog.component.scss'],
})

export class FilterSourceDialogComponent implements OnInit, OnDestroy {
    @ViewChild('file', {static: false})
    public file: ElementRef | undefined;

    @Input()
    public files: MultiSelectInterface[] = [];

    @Input()
    public moduleSelection: string[] = [];

    @Input()
    public fileSelection: string[] = [];

    private subscriptions: Subscription[] = [];

    private readonly bookUuid: string;

    public readonly buttonType = ButtonTypeEnum;

    public fileName: string = '';

    public fileType: string = '';

    public fileId: number = 0;

    public savedFile?: File;

    public resetToggle: boolean = false;

    public fileSelector: string[] = [];

    public moduleSelector: string[] = [];

    public selection: MultiSelectInterface[] = [];

    public selected?: MultiSelectInterface;

    public selectionOutput?: string;

    public constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        private dialogRef: MatDialogRef<FilterSourceDialogComponent>,
        public mimeTypeHelper: ExtensionHelper,
        public activatedRoute: ActivatedRoute,
        public store: Store,
    ) {
        const bookUuid = this.bookUuid = this.dialogData.bookUuid;

        this.files = dialogData.files;
        this.fileSelection = dialogData.fileSelection;
        this.moduleSelection = dialogData.moduleSelection;

        store.dispatch(LibraryActions.fetchChapters({bookUuid}));
    }

    public ngOnInit(): void {
        if(this.files === undefined) {
            return;
        }

        for(let i = 0; i <= this.files.length; i++) {
            if(this.fileSelection.includes(this.files[i]?.action)) {
                this.files[i].checked = true;
            }
        }
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public onSubmit(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this.dialogRef.close({moduleSelector: this.moduleSelector, fileSelector: this.fileSelector});
    }

    public onReset(): void {
        this.resetToggle = !this.resetToggle;
        this.fileSelector = [];

        for(let i = 0; i < this.files.length; i++) {
            this.files[i].checked = false;
        }
    }

    public onCancel(): void {
        this.dialogRef.close();
    }

    public moduleMultiSelect(multiSelect: any): void {
        this.moduleSelector = multiSelect;
    }

    public handleSelectedItem(file?: MultiSelectInterface, checked: boolean = false, event?: Event): void {
        if (event) {
            event.stopPropagation();
        }

        if (undefined === file || file === this.selected) {
            return;
        }

        if(file.action === '') {
            for(let i = 0; i < this.files.length; i++) {
                this.files[i].checked = file.checked = checked;
            }

            this.handleSelectedCheckBoxFinder();

            return;

        }
        const index = this.files.findIndex(data => data.action == file.action);

        this.files[index].checked = file.checked = checked;

        this.handleSelectedCheckBoxFinder();
    }

    public handleSelectedCheckBoxFinder(): void {
        let mimeTypes: string[] = [];

        this.files.map(file => {
            if (file.checked === true) {
                if (file.action != null && file.action !== '') {
                    mimeTypes.push(file.action);
                }
            }
        });

        this.fileSelector = mimeTypes;
    }
}
